import { log, logE } from "../../shared/services/debug-logger";
import { api, apiUrl } from "../../shared/services/service";
import {
  AdminUwhcProviderDeleteResponse,
  AdminUwhcProviderListResponse,
  AdminUwhcProviderMutationResponse,
  AdminUwhcProviderPayload,
} from "../models/admin-uwhc.models";
import axios from "axios";

export const getAdminUwhcProviders = async (): Promise<AdminUwhcProviderListResponse> => {
  try {
    log("REPO - getAdminUwhcProviders");
    const response = await api.get(`${apiUrl}/admin/uwhc/providers`);
    log("REPO - getAdminUwhcProviders - response", { status: response.status, count: response.data?.rows?.length });
    return response.data;
  } catch (error) {
    logE(error);
    throw error;
  }
};

export const createAdminUwhcProvider = async (
  provider: AdminUwhcProviderPayload,
): Promise<AdminUwhcProviderMutationResponse> => {
  try {
    log("REPO - createAdminUwhcProvider", { fields: Object.keys(provider).length });
    const response = await api.post(`${apiUrl}/admin/uwhc/providers`, { provider });
    log("REPO - createAdminUwhcProvider - response", { status: response.status });
    return response.data;
  } catch (error) {
    logE(error);
    throw error;
  }
};

export const updateAdminUwhcProvider = async (
  providerIdentifier: string,
  provider: AdminUwhcProviderPayload,
): Promise<AdminUwhcProviderMutationResponse> => {
  try {
    log("REPO - updateAdminUwhcProvider", { providerIdentifier });
    const response = await api.post(
      `${apiUrl}/admin/uwhc/providers/${encodeURIComponent(providerIdentifier)}/update`,
      { provider },
    );
    log("REPO - updateAdminUwhcProvider - response", { status: response.status });
    return response.data;
  } catch (error) {
    logE(error);
    throw error;
  }
};

export const deleteAdminUwhcProvider = async (
  providerIdentifier: string,
): Promise<AdminUwhcProviderDeleteResponse> => {
  try {
    log("REPO - deleteAdminUwhcProvider", { providerIdentifier });
    const response = await api.post(`${apiUrl}/admin/uwhc/providers/${encodeURIComponent(providerIdentifier)}/delete`);
    log("REPO - deleteAdminUwhcProvider - response", { status: response.status });
    return response.data;
  } catch (error) {
    logE(error);
    throw error;
  }
};

export const getAdminUwhcErrorMessage = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data as { error?: string; message?: string } | string | undefined;

    if (typeof responseData === "string") {
      return responseData;
    }

    return responseData?.error ?? responseData?.message ?? error.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "UWHC provider request failed.";
};
